import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { di } from 'react-magnetic-di';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { ON_INIT_CHANGE_ID } from '../../../../common/constants/constants';
import { addAppsErrors } from '../app-errors';
import { setNotification } from '../notification';
import { collectConflicts } from './utils/collect-conflicts';
var HISTORY_LOG_TTL = 60000;

/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */
var tidyUpAppliedChangesHistory = function tidyUpAppliedChangesHistory(appliedChangesHistory, changeId) {
  return Object.fromEntries(Object.entries(appliedChangesHistory).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      existingChangeId = _ref2[0],
      history = _ref2[1];
    return Date.now() - history.createdAt <= HISTORY_LOG_TTL || existingChangeId === changeId;
  }));
};
/**
 * Runs detection over applied changes history to find conflicts.
 * It sends notifications to apps, users and metrics.
 */
export var detectAppliedChangesConflicts = function detectAppliedChangesConflicts(_ref3) {
  var appId = _ref3.appId,
    changeId = _ref3.changeId;
  return function (_ref4, _ref5) {
    var setState = _ref4.setState,
      getState = _ref4.getState,
      dispatch = _ref4.dispatch;
    var viewType = _ref5.viewType,
      createAnalyticsEvent = _ref5.createAnalyticsEvent;
    var _getState = getState(),
      appliedChangesHistory = _getState.appliedChangesHistory;
    var tidyAppliedChangesHistory = tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
    setState({
      appliedChangesHistory: tidyAppliedChangesHistory
    });
    var appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
    var newChanges = appliedChangesHistoryChangeId === null || appliedChangesHistoryChangeId === void 0 ? void 0 : appliedChangesHistoryChangeId.apps[appId];
    if (!appliedChangesHistoryChangeId || !newChanges ||
    // No need to run conflicts checks for the first item in history
    Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) {
      return;
    }
    var lifecycleHook = changeId === ON_INIT_CHANGE_ID ? 'onInit' : 'onChange';
    var _collectConflicts = collectConflicts({
        appliedChangesHistory: appliedChangesHistoryChangeId.apps,
        newChanges: newChanges,
        appIdOfNewChanges: appId,
        lifecycleHook: lifecycleHook
      }),
      appErrorsMap = _collectConflicts.appErrorsMap,
      conflicts = _collectConflicts.conflicts;
    if (conflicts.length) {
      fireOperationalEvent(createAnalyticsEvent, {
        action: 'conflicted',
        actionSubject: 'jiraUiModifications.appliedChangesHistory',
        attributes: {
          conflictsCount: conflicts.length,
          conflicts: conflicts,
          conflictedApps: Object.keys(appErrorsMap),
          viewType: viewType
        }
      });
      dispatch(addAppsErrors({
        errors: appErrorsMap
      }));
      dispatch(setNotification({
        type: 'MULTIPLE_APPS_CONFLICTS'
      }));
    }
  };
};